import { FC } from 'react'
import { IconsProps } from '.'

const Exclamation: FC<IconsProps> = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...{ height, width }}
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <circle cx="12" cy="19" r="2" fill={color} />
      <path d="M10 3h4v12h-4z" fill={color} />
    </svg>
  )
}

export default Exclamation
